import { Projects } from "../Components/index";

export default Projects;
